import * as React from 'react'

import { PictogramArtGate } from '~/client/src/shared/icons/pictograms'

/** The picker's scrolling list, which a grid watches to know when it comes into view. */
export const PickerScrollRoot = React.createContext<HTMLElement | null>(null)

// Signs a grid holds load their art once it comes within this distance of view.
const LOAD_AHEAD = '200px'

function useIsNearView(ref: React.RefObject<HTMLElement>): boolean {
  const root = React.useContext(PickerScrollRoot)
  const [isNear, setIsNear] = React.useState(
    typeof IntersectionObserver === 'undefined',
  )

  React.useEffect(() => {
    const node = ref.current
    if (isNear || !node) {
      return
    }
    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setIsNear(true)
        }
      },
      { root, rootMargin: LOAD_AHEAD },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [isNear, ref, root])

  return isNear
}

interface IProps {
  children: React.ReactNode
}

export default function IconPickerGrid({
  children,
}: IProps): React.ReactElement {
  const ref = React.useRef<HTMLDivElement>(null)
  const isNearView = useIsNearView(ref)

  return (
    <div ref={ref} className="tw:flex tw:flex-wrap tw:gap-1.5 tw:p-2.5">
      <PictogramArtGate.Provider value={isNearView}>
        {children}
      </PictogramArtGate.Provider>
    </div>
  )
}
